import "../../../__snowpack__/pkg/braft-polyfill.js";
import "../../../__snowpack__/pkg/braft-editor/dist/index.css";
import "../../../__snowpack__/pkg/braft-extensions/dist/table.css";
import "../../../__snowpack__/pkg/braft-editor/dist/output.css";
import "./reset.css";
import "../../../__snowpack__/pkg/braft-extensions/dist/emoticon.css";
import "../../../__snowpack__/pkg/braft-extensions/dist/color-picker.css";
import React, {useContext, useEffect, useState, forwardRef, useImperativeHandle} from "../../../__snowpack__/pkg/react.js";
import {Modal} from "../../../__snowpack__/pkg/antd.js";
import LocaleContext from "../../../__snowpack__/pkg/antd/es/locale-provider/context.js";
import BraftEditor from "../../../__snowpack__/pkg/braft-editor.js";
import MaxLength from "../../../__snowpack__/pkg/braft-extensions/dist/max-length.js";
import {throttle} from "../../../__snowpack__/pkg/lodash.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import {EyeOutlined} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {extendControlsFontFamily, fontFamily} from "./includes/fontFamily.js";
import {SessionHelper} from "../../../__snowpack__/pkg/@genie/lib-iam-utils.js";
const i18n = {
  "zh-cn": {
    previewImg: "\u9884\u89C8",
    BLDescription: "\u63CF\u8FF0\u5FC5\u987B\u572830-3000\u5B57\u7B26\u4E4B\u95F4\uFF09",
    RichTextDescription: "\u5728\u6B64\u5904\u8F93\u5165\u60A8\u7684\u63CF\u8FF0\u5E76\u5C06\u5176\u5E94\u7528\u4E8E\u60A8\u7684\u4EA7\u54C1"
  },
  en: {
    previewImg: "Preview",
    BLDescription: "Description must be between 30-3000 characters",
    RichTextDescription: "Type your description here and apply it to your product"
  },
  id: {
    previewImg: "Pratinjau",
    BLDescription: "Deskripsi harus diantara 30-3000 karakter",
    RichTextDescription: "Tuliskan deskripsi di sini dan terapkan pada produk"
  },
  vi: {
    previewImg: "Preview",
    BLDescription: "Description must be between 30-3000 characters",
    RichTextDescription: "Type your description here and apply it to your product"
  },
  th: {
    previewImg: "Preview",
    BLDescription: "Description must be between 30-3000 characters",
    RichTextDescription: "Type your description here and apply it to your product"
  }
};
export const htmlToText = (html) => {
  return html.replace(/<[^<>]+>/g, "");
};
export const DartBraftEditor = forwardRef((props, ref) => {
  const {locale} = useContext(LocaleContext);
  const {value, loading, isController, url, maxLength, onBlur, disabled, placeholder, resetEditorProps} = props;
  const [predVisible, setPredVisible] = useState(false);
  const [outputHTML, setOutputHTML] = useState("");
  useImperativeHandle(ref, () => ({
    submit: async () => {
      return outputHTML;
    }
  }));
  const hooks = {
    "toggle-link": ({href, target}) => {
      href = href.indexOf("http") === 0 ? href : `http://${href}`;
      return {href, target};
    }
  };
  const preview = () => setPredVisible(true);
  const extendControls = [
    {
      key: "custom-button",
      type: "button",
      text: /* @__PURE__ */ React.createElement(EyeOutlined, null),
      title: i18n[locale].previewImg,
      onClick: preview
    },
    extendControlsFontFamily
  ];
  useEffect(() => {
    const options = {
      defaultValue: maxLength || 2e4
    };
    BraftEditor.use(MaxLength(options));
  }, []);
  const submitContent = async () => {
  };
  const myUploadFn = (param) => {
    const baseUrl = props?.isSpecial ? `/saas/product/v2/upload/upload-file` : `/saas/product/v1/images`;
    const serverURL = url ? url : baseUrl;
    const xhr = new XMLHttpRequest();
    const fd = new FormData();
    const successFn = (response) => {
      let jsonData = JSON.parse(xhr.responseText || "{}");
      let url2 = "";
      if (props?.isSpecial) {
        url2 = jsonData.code && jsonData.code == "SUCCESS" ? jsonData.data.fileUrl || "" : "";
      } else {
        url2 = jsonData.code && jsonData.code == "SUCCESS" ? jsonData.data || "" : "";
      }
      param.success({
        url: url2,
        meta: {
          loop: false,
          autoPlay: false,
          controls: false,
          poster: ""
        }
      });
    };
    const progressFn = (event) => {
      param.progress(event.loaded / event.total * 100);
    };
    const errorFn = () => {
      param.error({
        msg: "unable to upload."
      });
    };
    xhr.upload.addEventListener("progress", progressFn, false);
    xhr.addEventListener("load", successFn, false);
    xhr.addEventListener("error", errorFn, false);
    xhr.addEventListener("abort", errorFn, false);
    if (props?.isSpecial) {
      const {otherParams = {}} = props;
      Object.keys(otherParams).forEach((key) => {
        fd.append(key, otherParams[key]);
      });
      fd.append("file", param.file);
    } else {
      fd.append("image", param.file);
    }
    xhr.open("POST", serverURL, true);
    xhr.setRequestHeader("Authorization", SessionHelper.getSessionToken() ?? "");
    xhr.send(fd);
  };
  const handleCancel = () => setPredVisible(false);
  const generateQuickGuid = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  };
  let RichTextId = generateQuickGuid();
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "dart-braft-editor"
  }, isController ? !loading && /* @__PURE__ */ React.createElement(BraftEditor, {
    className: "my-editor",
    controls: props?.controls ? props.controls : [
      "undo",
      "redo",
      {
        key: "bold",
        text: /* @__PURE__ */ React.createElement("b", null, "B")
      },
      "italic",
      "list-ol",
      "list-ul",
      "remove-styles",
      "separator",
      "separator",
      "media",
      "clear"
    ],
    id: RichTextId,
    style: {border: "1px solid #e8e8e8"},
    placeholder: placeholder || i18n[locale].BLDescription,
    language: locale === "zh-cn" ? "zh" : "en",
    defaultValue: BraftEditor.createEditorState(value || ""),
    extendControls: [
      {
        key: "custom-button",
        type: "button",
        text: /* @__PURE__ */ React.createElement(EyeOutlined, null),
        title: i18n[locale].previewImg,
        onClick: preview
      }
    ],
    onBlur: throttle((val) => {
      setOutputHTML(val.toHTML() || outputHTML);
      onBlur(val.toHTML() || outputHTML);
    }, 1e3),
    onChange: throttle((val) => {
      setOutputHTML(val.toHTML());
      onBlur(val.toHTML() || outputHTML);
    }, 1e3),
    onSave: submitContent,
    contentStyle: {height: 400},
    media: {uploadFn: myUploadFn},
    ...resetEditorProps
  }) : !loading && /* @__PURE__ */ React.createElement(BraftEditor, {
    readOnly: props.disabled,
    className: "my-editor",
    textBackgroundColor: true,
    id: RichTextId,
    hooks,
    style: {border: "1px solid #e8e8e8"},
    placeholder: placeholder || i18n[locale].RichTextDescription,
    language: locale === "zh-cn" ? "zh" : "en",
    defaultValue: BraftEditor.createEditorState(value ? `<div>${value}</div>` : value),
    onBlur: throttle((value2) => {
      setOutputHTML(value2.toHTML() || outputHTML);
      onBlur(value2.toHTML() || outputHTML);
    }, 1e3),
    onChange: throttle((val) => {
      setOutputHTML(val.toHTML());
      onBlur(val.toHTML() || outputHTML);
    }, 1e3),
    onSave: submitContent,
    contentStyle: {height: 400},
    media: {uploadFn: myUploadFn},
    fontFamilies: fontFamily,
    extendControls
  }), maxLength && /* @__PURE__ */ React.createElement("div", {
    className: "editor-count"
  }, htmlToText(outputHTML || props.value || "").length, "/", maxLength), predVisible && /* @__PURE__ */ React.createElement(Modal, {
    title: i18n[locale].previewImg,
    visible: predVisible,
    width: 800,
    centered: true,
    bodyStyle: {
      height: 400,
      padding: "0 24px",
      overflow: "auto"
    },
    footer: false,
    onCancel: handleCancel
  }, /* @__PURE__ */ React.createElement(EditorPreviewStyled, null, /* @__PURE__ */ React.createElement("div", {
    className: "container",
    contentEditable: "false",
    dangerouslySetInnerHTML: {__html: outputHTML}
  }))));
});
const Wrapper = styled.div`
  .editor-count {
    margin-top: 8px;
    text-align: right;
    font-size: 10px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #7f8fa4;
    line-height: 12px;
  }
`;
const EditorPreviewStyled = styled.div`
  html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #f1f2f3;
  }
  .container {
    box-sizing: border-box;
    width: 100%;
    height: 100vh;
    max-width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    padding: 30px 20px;
    overflow: hidden;
    background-color: #fff;
    border-right: solid 1px #eee;
    border-left: solid 1px #eee;
  }
  .container img,
  .container audio,
  .container video {
    max-width: 100%;
    height: auto;
  }
  .container p {
    white-space: pre-wrap;
    min-height: 1em;
  }
  .container pre {
    padding: 15px;
    background-color: #f1f1f1;
    border-radius: 5px;
  }
  .container blockquote {
    margin: 0;
    padding: 15px;
    background-color: #f1f1f1;
    border-left: 3px solid #d1d1d1;
  }
`;
